import { NormalizedStore } from '@store/entity/entity.types';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import moment from 'moment';
import { connect } from 'react-redux';
import { change, clearFields } from 'redux-form';
import { SPA_PACKAGE_FORM_NAME } from '../../../shared';
import { DateSelector } from './DateSelector';
import { DispatchProps, StateProps } from './DateSelector.types';

const mapStateToProps = (state: NormalizedStore): StateProps => ({
  activeDate: moment(yourJourneySelectors.getParsedJourneyParams(state).spaDate),
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  setActiveDate: (value) => dispatch(changeJourneyParam('spaDate', value)),
  clearFormField: (fieldName) =>
    dispatch(clearFields(SPA_PACKAGE_FORM_NAME, false, false, fieldName)),
  change: (fieldName, value) => dispatch(change(SPA_PACKAGE_FORM_NAME, fieldName, value)),
});

export const DateSelectorConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(DateSelector);
